module.exports = __webpack_public_path__ + "img/女生头像正.fb8a8bf7.png";